export const ASYNC_ACTION_START = 'common/ASYNC_ACTION_START';
export const ASYNC_ACTION_END = 'common/ASYNC_ACTION_END';

export const CONFIRM_ACTION = 'common/CONFIRM_ACTION';
export const CONFIRM_ACTION_CANCEL = 'common/CONFIRM_ACTION_CANCEL';

export const CHOOSE_BASIC_PLAN = 'common/CHOOSE_BASIC_PLAN';
export const CHOOSE_PLUS_PLAN = 'common/CHOOSE_PLUS_PLAN';
export const CHOOSE_PREMIUM_PLAN = 'common/CHOOSE_PREMIUM_PLAN';
export const CHOOSE_NO_PLAN = 'common/CHOOSE_NO_PLAN';
export const CHOOSE_PLAN = 'common/CHOOSE_PLAN';
